import { render, staticRenderFns } from "./ovrz1.vue?vue&type=template&id=21121e32"
import script from "./ovrz1.vue?vue&type=script&lang=js"
export * from "./ovrz1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports